import React from "react";
import { View } from "react-native";
import { AutoWidthImage } from "../../Universal/Image/AutoWidthImage";
import { PressableWrap } from "../../Universal/Buttons/PressableColorWrap/PressableColorWrap";

interface ImageSwiperSlideProps {
  image: string;
  index: number;
  itemHeight: number;
  itemWidth: number;
  scaleAll: number;
  slideInnerStyle: object;
  slidePressableStyle: object;
  onFocus: () => void;
  onPress?: ({ index }: { index: number }) => any;
}

const ImageSwiperSlide: React.FC<ImageSwiperSlideProps> = ({
  image,
  index,
  itemHeight,
  itemWidth,
  scaleAll,
  slideInnerStyle,
  slidePressableStyle,
  onFocus,
  onPress,
}) => (
  <PressableWrap
    onPress={() => {
      onFocus();
      onPress?.({ index });
    }}
    style={[slidePressableStyle, { width: itemWidth, height: itemHeight }]}
  >
    <View style={[slideInnerStyle, { width: itemWidth, height: itemHeight }]}>
      <AutoWidthImage
        height={itemHeight}
        scaleAll={scaleAll}
        source={{ uri: image }}
        maxWidth={itemWidth}
      />
    </View>
  </PressableWrap>
);

export default React.memo(ImageSwiperSlide);
